import {
  validRegistrationCollections,
  type RegistrationCollections,
} from "@tu/conference-connector-contract";

export function collectionChartDays(
  data: RegistrationCollections,
  range: "all" | "30" | "90",
) {
  if (!validRegistrationCollections(data) || !data.days.length) return [];
  const end = Date.parse(`${data.throughDate}T00:00:00Z`);
  const first = Date.parse(`${data.days[0]!.date}T00:00:00Z`);
  const start =
    range === "all"
      ? first
      : Math.max(first, end - (Number(range) - 1) * 86400000);
  if ((end - start) / 86400000 > 10000) return [];
  const map = new Map(data.days.map((day) => [day.date, day]));
  const result = [];
  for (let time = start; time <= end; time += 86400000) {
    const date = new Date(time).toISOString().slice(0, 10);
    result.push(map.get(date) ?? { date, invoiceCount: 0, amountMinor: 0 });
  }
  return result;
}
